import React from "react";
import { createPortal } from "react-dom";
import DOMPurify from "dompurify";
import { ResourceDto } from "../types/resources";
import "../styles/resources.css";

interface LaunchModalProps {
    resource: ResourceDto;
    onClose: () => void;
    onLaunch: () => void;
}

export default function LaunchModal({ resource, onClose, onLaunch }: LaunchModalProps) {
    const sanitizedContent = DOMPurify.sanitize(resource.launchModalContent);

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return createPortal(
        <div className="resource-modal-overlay" onClick={handleOverlayClick}>
            <div className="resource-modal">
                <button className="resource-modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
                <div className="resource-modal-content">
                    <h2 className="resource-modal-heading">{resource.launchModalHeading}</h2>
                    <div
                        className="resource-modal-body"
                        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                    />
                    <div className="resource-modal-actions">
                        <button className="resource-modal-launch-btn" onClick={onLaunch}>
                            {resource.launchModalButton}
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

